module.exports = __webpack_public_path__ + "static/media/ethmoji.83a337e7.png";